/**
 * @todo rewrite in vanilla js
 */
export default function() {
    const $toggle = $(".accordion__target");
    
    $toggle.on('click', function() {
        let $item = $(this).parents(".accordion__item");
        // toggle previous active item
        let $previousItem = $item.parent(".accordion").find(".accordion__item--active").not($item);
        if ( $previousItem ) toggleItem($previousItem);
        
        // toggle current item
        toggleItem($item);
    });

    // open first item in accordions
    $(".accordion--default-open > :first-child").each(function() {
        toggleItem($(this));
    });
}

function toggleItem($item) {
    // toggle item active class
    $item.toggleClass('accordion__item--active');

    // set items height so css can transition from closed to proper height
    const $body = $item.find(".accordion__body");
    if ( $body.get(0) ) {
        if ( $item.hasClass('accordion__item--active') ) {
            // when activating set height to element's natural height
            const height = $body.get(0).scrollHeight;
            $body.css('height', height);
        } else {
            // hide by setting height to 0
            $body.css('height', 0);
        }
    }
}